export enum TimeLimitation {
  unknown = 'unknown',
  heltid = 'heltid',
  lagtrafik = 'lagtrafik',
  skolkort04Till19 = 'skolkort04till19',
  skolkort04Till22 = 'skolkort04till22',
  skolkort04Till1930 = 'skolkort04till1930',
  fritid100 = 'fritid100',
  fritidKomplement = 'fritidkomplement',
  fritidVardag19Till22 = 'fritidvardag19till22',
  fritidVardag14Till24 = 'fritidvardag14till24',
  fritidKvallHelg = 'fritidkvallhelg',
  fritidKvallHelgLov = 'fritidkvallhelgLov',
  fritidJulSommarlov = 'fritidjulsommarlov',
  fritidAle = 'fritidale',
}
